import Components from './Choose.vue';

const choose = {
    install:function(Vue) {
        Vue.component('choose', Components)
    }
}

export default choose;